<template>
    <v-dialog v-model="show" max-width="500">
        <v-card>
            <v-card-title>
                <span class="tit tit--xs"><b>상품정보 다운로드</b></span>
            </v-card-title>

            <v-divider/>

            <v-card-text>
                <v-radio-group v-model="type" label="선택구분" row dense hide-details>
                    <v-radio label="기본선택" value="basic" class="ma-0 mx-2 "/>
                    <v-radio label="전체선택" value="all" class="ma-0 mx-2 "/>
                </v-radio-group>
            </v-card-text>

            <v-divider/>

            <v-card-title class="pb-2">
                <span class="tit tit--xs">기본정보</span>
            </v-card-title>

            <v-card-text>
                <v-layout wrap>
                    <v-checkbox v-model="selected" label="상품코드" value="code" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="상품명" value="name" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="카테고리" value="category" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="상품진열" value="onDisplay" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="품절여부" value="soldout" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="재고량" value="stock" dense hide-details class="mr-2"/>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-card-title class="pb-2">
                <span class="tit tit--xs">가격 및 옵션</span>
            </v-card-title>

            <v-card-text>
                <v-layout wrap>
                    <v-checkbox v-model="selected" label="소비자가(정가)" value="costPrice" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="판매가" value="salePrice" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="적립 포인트" value="pointPercent" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="옵션" value="optionalProducts" dense hide-details class="mr-2"/>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-card-title class="pb-2">
                <span class="tit tit--xs">상품 사진 / 설명</span>
            </v-card-title>

            <v-card-text>
                <v-layout wrap>
                    <v-checkbox v-model="selected" label="상품사진" value="images" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="작가" value="writer" dense hide-details class="mr-2"/>
                    <v-checkbox v-model="selected" label="출판사" value="publisher" dense hide-details class="mr-2"/>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-divider/>

            <v-card-title class="pb-2">
                <span class="tit tit--xs">공제 분류</span>
            </v-card-title>

            <v-card-text>
                <v-layout wrap>
                    <v-checkbox v-model="selected" label="공제여부" value="isDeduction" dense hide-details class="mr-2"/>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-divider/>

            <v-card-title class="pb-2">
                <span class="tit tit--xs">배송정책</span>
            </v-card-title>

            <v-card-text>
                <v-layout wrap>
                    <v-checkbox v-model="selected" label="배송정책" value="shippingCode" dense hide-details class="mr-2"/>
                </v-layout>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="close">취소</v-btn>
                <v-btn text color="primary" @click="confirm">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data(){
        return {
            show: false,

            type: null,

            seleted: []
        }
    },
    mounted(){
        this.type = "basic";
    },
    methods: {
        close(){
            this.show = false;
        },
        open(){
            this.show = true;
        },
        confirm(){
            this.$emit("confirm", this.selected);
            this.close();
        }
    },
    watch: {
        type(){
            switch(this.type){
                case "basic": this.selected = ["code","name","category","salePrice","costPrice","optionalProducts","images","writer","publisher", "isDeduction", "shippingCode"]; return;
                case "all": this.selected = ["code","name","category", "onDisplay", "soldout", "stock", "salePrice","costPrice", "pointPercent", "optionalProducts","images","writer","publisher", "isDeduction", "shippingCode"]; return;
            }
        }
    }
}
</script>